<template>
  <div class="w-full bg-gray-50 pb-4">
    <div v-for="group in groups" v-bind:key="group.id" class="w-full bg-gray-50 text-gray-600 text-sm">
      <div class="pl-10 pt-3">
        <div class="text-xl font-bold">{{ group.name }}</div>
      </div>
      <div class="mx-6 mt-2 p-2 pb-4 bg-white rounded-lg flex flex-wrap">
        <div v-for="feature in group.children" v-bind:key="feature.id" class="w-1/4 pl-2 pt-2">
          <div :class="['px-1 h-8 flex flex-row items-center border-2 rounded hover:border-blue-500 hover:bg-blue-100 hover:text-blue-500 cursor-pointer', featurePresent(feature) ? 'bg-green-100 border-green-500 text-green-600': 'border-gray-200 text-gray-500']" @click="selectFeature(feature)">
            <span class="text-3xl icon-feature-10"></span>
            <span class="ml-3 text-xs truncate">{{feature.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from 'lodash';

export default {
  name: "Features",
  data() {
    return {
      loading: true,
      features: [],
      groups: []
    }
  },
  methods: {
    lead() {
      return this.$store.getters['seller/lead'];
    },
    selectMenu(menu) {
      this.$emit('select-detail-menu', menu);
    },
    selectFeature(feature) {
      let fts = _.cloneDeep(this.lead().condition.features);
      if(_.filter(fts, (ft) => {return ft.id == feature.id }).length>0) {
        _.remove(fts, (ft) => {return ft.id == feature.id});
      } else {
        fts.push(feature);
      }
      this.lead().condition.features = fts;
    },
    signalLoaded() {
      this.loading = false;
      this.groups = [];
      let currentGroup = { id: 0 };
      _.each(this.features, (feature) => {
        if(currentGroup.id!==feature.group_id) {
          let newGroup = {
            id: feature.group_id,
            name: feature.group,
            children: []
          }
          this.groups.push(newGroup);
          currentGroup = newGroup;
        }
        currentGroup.children.push(feature);
      });
    },
    featurePresent(feature) {
      if(this.lead().condition.features.length===0) {
        _.each(this.lead().condition.car.equipments, (e) => {
          if (_.filter(this.lead().condition.features, ft => ft.id == e.generalId).length == 0) {
            let sel = _.filter(this.features, ft => ft.id == e.generalId);
            if(sel.length>0) this.lead().condition.features.push(sel[0]);
          }
        });
      }
      return _.filter(this.lead().condition.features, (ft) => ft.id == feature.id).length > 0;
    }
  },
  watch: {
  },
  created() {
    if(this.$store.getters['tradein/features']!==undefined&&this.$store.getters['tradein/features']!==null) {
      this.features = this.$store.getters['tradein/features'];
      this.signalLoaded();
    } else {
      axios.get('/manager/fleet/features/all/').then(response => {
        if (response.status === 200) this.$store.commit('tradein/setFeatures', response.data.features);
        this.features = response.data;
        this.signalLoaded();
      });
    }
  },
}
</script>

<style scoped>

</style>